import {IconEye, IconEyeOff, IconLoader2, IconRefresh, IconWallet} from "@tabler/icons-react";
import {Spin} from "@ui";
import {useEffect, useState} from "react";
import CurrencyDropdown from "../../../../../components/CurrencyDropdown";
import UserAvatar from "../../../../../components/NavBar/Avatar";
import NotificationMenu from "../../../../../components/notification";
import useGetUserInfo from "../../../../../hooks/useGetUserInfo";
import useGetUserWallet from "../../../../../hooks/wallet/useGetUserWallet";
import BaseMenu from "../../../../../Layout/components/BaseMenu";
import {useBalanceStore} from "../../../../../store/useBalance.store";
import useCurrencyStore from "../../../../../store/useCurrency.store";
import {useMonogram} from "../../../../../util/logoUtils";
import styles from "./PaymentProfileCard.module.css";

const PaymentProfileCard = () => {
  const monogram = useMonogram();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showAmount, setShowAmount] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);

  const widthResponsive = 800; // before it was 640, but I needed to make it 800 because in testing it was inner width was 713
  const isMobile = 640;

  // const iconFontSize = 15;

  const {data: userInfo} = useGetUserInfo();
  const {isLoading: isBalanceLoading, balance, getAccountByCurrency, refetch} = useGetUserWallet();
  const {selectedCurrency} = useCurrencyStore();

  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);

  // Get account for selected currency
  const selectedAccount = selectedCurrency ? getAccountByCurrency(selectedCurrency.id) : balance;

  // Use the selected account or default to VES balance
  const accountToDisplay = selectedAccount || balance;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleReload = () => {
    setIsSpinning(true);
    refetch();
  };

  return (
    <div className={styles.nav_container}>
      {windowWidth < widthResponsive && (
        <div className={styles.nav_inner}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{display: "flex", gap: "15px", alignItems: "center"}}>
              <img
                src={monogram}
                alt="AyG Logo"
                style={{height: 28, width: "auto"}}
              />
              {windowWidth > isMobile && windowWidth < widthResponsive ? (
                <h4 style={{margin: "0px"}}>
                  {userInfo?.given_name
                    ? userInfo.given_name.charAt(0).toUpperCase() + userInfo.given_name.slice(1)
                    : ""}{" "}
                  {userInfo?.family_name
                    ? userInfo.family_name.charAt(0).toUpperCase() + userInfo.family_name.slice(1)
                    : ""}
                </h4>
              ) : (
                ""
              )}
            </div>
            <div className={styles.iconBox__inner}>
              <BaseMenu />
              <div className={styles.DetailsBox__inner}>
                <div>
                  {isBalanceLoading ? (
                    <Spin
                      indicator={
                        <IconLoader2
                          size={16}
                          className="icon-spin"
                        />
                      }
                      size="small"
                    />
                  ) : showAmount ? (
                    accountToDisplay?.formattedBalance || "Bs. 0,00"
                  ) : accountToDisplay?.formattedBalance ? (
                    "*".repeat(accountToDisplay.formattedBalance.length)
                  ) : (
                    "***"
                  )}
                </div>
                <CurrencyDropdown />
                <div className={styles.detailsShow}>
                  <span onClick={() => setShowAmount(!showAmount)}>
                    {showAmount ? (
                      <IconEyeOff
                        size={16}
                        stroke={2}
                      />
                    ) : (
                      <IconEye
                        size={16}
                        stroke={2}
                      />
                    )}
                  </span>
                  <IconRefresh
                    size={16}
                    stroke={2}
                    className={isSpinning ? styles.spin : ""}
                    onClick={handleReload}
                    onAnimationEnd={() => setIsSpinning(false)}
                  />
                </div>
              </div>

              <div
                onClick={() => handleBankAccountModal()}
                className={styles.walletIcon}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") handleBankAccountModal();
                }}
              >
                <IconWallet
                  size={22}
                  stroke={1.8}
                />
              </div>
              <NotificationMenu />
              <UserAvatar size={45} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentProfileCard;
